import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './assets/main.css'

// Import views
import LoginView from './views/LoginView.vue'
import DashboardView from './views/DashboardView.vue'
import GameDetailView from './views/GameDetailView.vue'
import AllGamesView from './views/AllGamesView.vue'
import SettingsView from './views/SettingsView.vue'

// Import stores
import { useAuthStore } from './stores/auth'

// Router configuration
const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginView,
        meta: { requiresAuth: false }
    },
    {
        path: '/',
        name: 'Dashboard',
        component: DashboardView,
        meta: { requiresAuth: true }
    },
    {
        path: '/games',
        name: 'AllGames',
        component: AllGamesView,
        meta: { requiresAuth: true }
    },
    {
        path: '/game/:id',
        name: 'GameDetail',
        component: GameDetailView,
        meta: { requiresAuth: true }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: SettingsView,
        meta: { requiresAuth: true }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// Navigation guard
router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore()
    
    // Check if route requires authentication
    if (to.meta.requiresAuth) {
        // Verify token if we have one
        if (authStore.token) {
            const isValid = await authStore.verifyToken()
            if (!isValid) {
                next('/login')
                return
            }
        } else {
            next('/login')
            return
        }
    }
    
    // If already authenticated and trying to access login, redirect to dashboard
    if (to.name === 'Login' && authStore.isAuthenticated) {
        next('/')
        return
    }
    
    next()
})

// Create app
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')